import queryString from 'query-string'

export const getRouteName = store => (route, nextState, replace) => {
  const queryValues = queryString.parse(nextState.location.search)
  const device = queryValues['device']
  if (device === undefined && ['faqs', 'videos', 'tutorials', 'guides'].includes(route)) {
    replace(({
      pathname: '/',
      query: queryValues
    }))
  }
    
  nextState.routes[1].name = route
  return nextState
}



// WEBPACK FOOTER //
// ./src/routes/helpers.js